import { TransactionFlow } from '../enums';
const PIX_RECEIPT_FLOW_PATH = {
    [TransactionFlow.CASH_IN]: 'IN',
    [TransactionFlow.CASH_OUT]: 'OUT',
    [TransactionFlow.REVERSAL_IN]: 'REVERSAL_IN',
    [TransactionFlow.REVERSAL_OUT]: 'REVERSAL_OUT',
};
export function mapPixReceiptFlow(transactionFlow) {
    return PIX_RECEIPT_FLOW_PATH[transactionFlow];
}
